export default __webpack_public_path__ + "assets/youtube.31a825cc.svg";